import { useCallback } from 'react';

/**
 * Hook for performing optimistic updates with automatic rollback on failure
 */
export const useOptimisticUpdate = () => {
  const withOptimisticUpdate = useCallback(async <T,>(
    updateFn: () => Promise<T>,
    optimisticUpdate: () => void,
    revertFn: () => void
  ): Promise<T> => {
    try {
      // Apply optimistic update immediately
      optimisticUpdate();
      
      // Execute the actual operation
      const result = await updateFn();
      
      return result;
    } catch (error) {
      console.error('Optimistic update failed, reverting:', error);
      revertFn();
      throw error;
    }
  }, []);

  return { withOptimisticUpdate };
};